import Script from 'next/script';

export const Opensend = () => {
	return (
    <>
		<Script
        src="https://cdn.aggle.net/oir/oir.min.js"
        strategy="afterInteractive"
        onLoad={() => {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.text = `
            !function(e) {
              let t = {};
              (e._oirtrk = e._oirtrk || []).push(['track', 'on-site', t]);
            }(window);
          `;
          document.body.appendChild(script);
        }}
        onReady={() => {
          // Set attributes manually after script tag is created
          const loadedScript = document.querySelector('script[src="https://cdn.aggle.net/oir/oir.min.js"]');
          if (loadedScript) {
            loadedScript.setAttribute('oirtyp', '6311ae17');
            loadedScript.setAttribute('oirid', 'PF4M4B9C2');
          }
        }}
      />
    </>
	);
};
